<template>
  <div>
    <div class="text-xl font-black py-2">1. Performance Review</div>

    <!-- Sub section -->
    <div class="pt-2">
      <div class="font-black text-lg py-2">Referrals</div>
      <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
        <review-question-component v-model="form.questions[page][sectionStart][index]" :showMandatory="showMandatory"></review-question-component>
        <hr class="border-b my-8" />
      </div>
    </div>

    <div class="pt-2">
      <div>Would you like more referrals and to generate more revenue from passing referrals?</div>
      <div>Our new referral system enables this with increased automation.</div>
      <div v-for="(question2, index2) in form.questions[page][sectionStart+1]" :key="index2">
        <review-question-component v-model="form.questions[page][sectionStart+1][index2]" container-class="flex justify-between w-full" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>

    <hr class="border-b my-8 border-green-600" />
    <div class="pt-2">
      <div class="font-black text-lg py-2">Challenges</div>
      <div>Please rate the following challenges from 1-5. 1 being the highest priority.</div>
      <div class="flex w-full justify-between pt-4">
        <div class="py-2"></div>
        <div class="w-1/2 flex justify-between">
          <div class="pr-8">1</div>
          <div class="pr-8">2</div>
          <div class="pr-8">3</div>
          <div class="pr-8">4</div>
          <div class="pr-8">5</div>
        </div>
      </div>
      <div v-for="(question3, index3) in form.questions[page][sectionStart+2]" :key="index3">
        <hr class="border-b my-4" />
        <review-question-component v-model="form.questions[page][sectionStart+2][index3]" column-class="w-1/2 flex justify-between" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  },
  mounted () {
  }
}
</script>
